/*
 * @Author: gaobin
 * @Date: 2025-07-29 13:46:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-06 11:07:23
 * @Description: 点击事件埋点追踪
 */
class EventTracker {
  constructor() {
    this.events = [];
  }

  // 手动增加页面pv事件
  addPagePvTracker(params) {
    this.events.push(...params);
    console.log('tracker log=> 当前事件集合', this.events);
  }

  /**
   * 手动添加点击事件
   * @param {Object} eventText 事件描述
   */
  addClickEventTracker(eventText) {
    const pages = getCurrentPages();

    // 当前路由
    const curRoute = pages[pages.length - 1]?.route || '';

    const simplifiedEvent = {
      action: 'click',
      pageUrl: `${curRoute}/${eventText}`,
    };
    this.events.push(simplifiedEvent);
    console.log('tracker log=> 当前事件集合', this.events);
  }

  /**
   * 获取并清空事件集合
   */
  getAndClear() {
    const events = [...this.events];
    // console.log('tracker log=> 获取并清空事件集合', this.events);
    this.events = [];
    return events;
  }
}

export const eventTracker = new EventTracker();
